import { loadPrefs } from './session'

let audioCtx: AudioContext | null = null

/** Must be called from a user gesture once (iOS) so later chimes can play. */
export const unlockAudio = () => {
  try {
    audioCtx ??= new AudioContext()
    if (audioCtx.state === 'suspended') void audioCtx.resume()
  } catch {
    // no audio
  }
}

/**
 * A short chime synthesised on the fly (no asset needed). Only for phase changes, which every phone plays at the
 * same moment: never for one player's own turn or actions, or the people sitting nearby would hear who is awake
 * at night (and so, by the wake order, who is what).
 */
export const chime = (kind: 'dawn' | 'dusk' | 'vote') => {
  if (!loadPrefs().sound || !audioCtx) return
  try {
    const notes = kind === 'dusk' ? [220, 165] : kind === 'dawn' ? [330, 440, 550] : [262, 262]
    const t0 = audioCtx.currentTime
    notes.forEach((f, i) => {
      const osc = audioCtx?.createOscillator()
      const gain = audioCtx?.createGain()
      if (!osc || !gain || !audioCtx) return
      osc.type = 'triangle'
      osc.frequency.value = f
      gain.gain.setValueAtTime(0.0001, t0 + i * 0.18)
      gain.gain.exponentialRampToValueAtTime(0.12, t0 + i * 0.18 + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + i * 0.18 + 0.35)
      osc.connect(gain).connect(audioCtx.destination)
      osc.start(t0 + i * 0.18)
      osc.stop(t0 + i * 0.18 + 0.4)
    })
  } catch {
    // ignore
  }
}

/** A buzz is audible across a table: the board hushes vibration for the whole night (see BoardScreen). */
let hushed = false
export const hushVibration = (on: boolean) => {
  hushed = on
}

export const vibrate = (pattern: number | number[] = 30) => {
  if (hushed || !loadPrefs().haptics) return
  try {
    navigator.vibrate?.(pattern)
  } catch {
    // ignore
  }
}
